import {StyleSheet} from "aphrodite-jss"

export const styles = StyleSheet.create({
    container : {
        height: "wrap-content",
        minHeight: "200px",
        width: "700px",
        backgroundColor: "white",
        padding: "10px",
    },
    content: {
        display: "flex",
        flexDirection: "column"
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold"
    },
    source: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        margin: "10px 10px 0px 5px",
        fontSize: "14px",
        "& #label": {
            fontSize: "14px",
            fontWeight: "bold",
            marginRight: "10px"
        }
    },
    doi: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        margin: "5px 10px 0px 5px",
        fontSize: "14px",
        "& #label": {
            fontSize: "14px",
            fontWeight: "bold",
            marginRight: "10px"
        }
    },
    date: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        margin: "5px 10px 0px 5px",
        fontSize: "14px",
        "& #label": {
            fontSize: "14px",
            fontWeight: "bold",
            marginRight: "10px"
        }
    },
    authors: {
        margin: "10px 10px 15px 5px",
        fontSize: "14px",
        "& #label": {
            fontSize: "16px",
            fontWeight: "bold"
        }
    },
    abstract: {
        margin: "5px 10px 15px 5px",
        "& #label": {
            fontSize: "16px",
            fontWeight: "bold"
        }
    },
    keywords: {
        display: "flex",
        flexDirection: "row",
        margin: "5px 10px 15px 5px",
        "& #label": {
            fontSize: "16px",
            fontWeight: "bold",
            marginRight: "5px"
        }
    },
    
    projects: {
        "& th, td": {
            "border": "1px solid black",
            padding: "0px 5px 0px 5px"
        },
        "& #id, #year, #budget": {
            width: "100px"
        },
        "& #people_content": {
            display: "inline"
        }
    }


});


// WEBPACK FOOTER //
// ./src/components/dialogs/AwardDetailDialogStyle.ts